import React from 'react';

import { IconProps } from '../../Icon.types';

export const OmegaIcon = (props: IconProps) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7563 4.33979C9.96159 3.74141 8.99374 3.41785 7.99893 3.41797C7.00411 3.41809 6.03634 3.74187 5.24175 4.34044C4.44716 4.939 3.86888 5.77984 3.59425 6.736C3.31961 7.69216 3.36353 8.71171 3.71936 9.64071C4.0752 10.5697 4.72363 11.3577 5.56675 11.8857L5.16867 12.5214L5.56237 11.883C5.71993 11.9802 5.85032 12.1157 5.9414 12.2768C6.03249 12.438 6.0813 12.6195 6.08329 12.8046L6.08338 12.8127L6.08333 13.0007C6.08333 13.288 5.9692 13.5636 5.76603 13.7667C5.56287 13.9699 5.28731 14.084 5 14.084H2C1.58579 14.084 1.25 13.7483 1.25 13.334C1.25 12.9198 1.58579 12.584 2 12.584H3.99877C3.25429 11.9341 2.67554 11.1091 2.3186 10.1772C1.84631 8.9442 1.78803 7.59098 2.15254 6.3219C2.51706 5.05282 3.28458 3.93679 4.33922 3.14234C5.39387 2.34788 6.67836 1.91812 7.99875 1.91797C9.31914 1.91781 10.6037 2.34726 11.6586 3.14147C12.7134 3.93568 13.4812 5.05153 13.846 6.32052C14.2108 7.58952 14.1528 8.94276 13.6808 10.1759C13.324 11.1083 12.745 11.9338 12.0002 12.584H14C14.4142 12.584 14.75 12.9198 14.75 13.334C14.75 13.7483 14.4142 14.084 14 14.084H11C10.7127 14.084 10.4371 13.9699 10.234 13.7667C10.0308 13.5636 9.91667 13.288 9.91667 13.0007V12.8061C9.9183 12.6206 9.96698 12.4386 10.0581 12.2771C10.1486 12.1166 10.2781 11.9815 10.4346 11.8843C11.2768 11.356 11.9245 10.5683 12.28 9.6397C12.6356 8.71062 12.6792 7.69105 12.4044 6.73496C12.1295 5.77887 11.5511 4.93816 10.7563 4.33979Z"
        fill={props.color}
      />
    </svg>
  );
};
